import { t } from 'i18next';
import { assertAffectedRecord, queryKeys, sdk } from 'utils/query';
import { EmptyParametersError } from 'services/errors/EmptyParametersError';
import { useCustomMutation } from '../../useCustomMutation';

interface DisableMfaProps {
  userId?: string;
  presenceToken: string;
}

const disableMfaMethod = async ({ userId, presenceToken }: DisableMfaProps) => {
  if (!userId) throw new EmptyParametersError();
  const result = await sdk.auth.users.disableMfa(userId, { presenceToken });
  return assertAffectedRecord({ result });
};

export const useDisableMfa = () => {
  return useCustomMutation({
    fn: disableMfaMethod,
    onSuccess: {
      message: t('notifications_two_step_disabled'),
      invalidateQueryKeys: [[queryKeys.userData]],
      closeDrawer: true,
    },
  });
};
